// extracted by mini-css-extract-plugin
module.exports = {"cardMargin":"src-components-flowable-IRBStudy-IRBStudy___cardMargin"};